import React, { PropsWithChildren } from 'react'
import BaseDetailVerticalTab from '../../../components/DetailVerticalTab/DetailVerticalTab'
import { TabContentType } from '../../../components/DetailVerticalTab/types'
import { BodyType } from '../ImageColumns'

export type ContentType = {
    title: string
    body: string
    subtitle: string
    content: BodyType[]
    content_lower: BodyType[]
}

type DetailVerticalTabType = {
    tabs: ContentType[]
    title:string
    color?: string
}

const DetailVerticalTab:React.FC<PropsWithChildren<{ slice:DetailVerticalTabType }>> = ({ slice })  => {
  const { title, tabs, color } = slice
  const tabList: string[] =[]
  const tabContent: TabContentType [] = []

  tabs.map((item,index)=> {
    tabContent.push({
      id: index,
      title:item.body,
      subtitle: item.subtitle,
      content: item.content,
      lowerContent: item.content_lower,
    })
    tabList.push(item.title)
  })

  const tabsData = {
    tabContent:tabContent,
    tabList:tabList,
    title:title,
  }

  return tabList.length === 0 ? null : (
    <BaseDetailVerticalTab data={tabsData} strokeColor={color}/>
  )
}

export default DetailVerticalTab